import gql from 'graphql-tag'

export default gql`
query recurringOccurrences(
  $recurrence: Json!
  $date: DateTime!
  $count: Int!
  $timezone: String!
) {
  recurringOccurrences(
    recurrence: $recurrence
    date: $date
    count: $count
    timezone: $timezone
  ) {
    occurrences
    hasMore
  }
}
`
